import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Nav, Accordion, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid, regular, brands } from '@fortawesome/fontawesome-svg-core/import.macro'
import logo from '../images/Giftr-Seller-Center-Logo.svg';

const country = window.location.hostname === 'seller.giftr.my' ? 'MY' : 'SG'

const isActiveRoute = (pathName, route) => {
  return pathName === route;
}

const Sidebar = ({ location: { pathname }, user, notifications: { open_count, pickup_reminder_count }, isCollapsed, onToggleCollapse }) => {
  return (
      <Nav className="nav-sidebar flex-column mb-0">
        <button 
          className="collapse-toggle btn btn-link d-flex align-items-center mb-3 ms-3"
          onClick={onToggleCollapse}
          title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <FontAwesomeIcon 
            icon={solid('bars')} 
            className={`toggle-icon ${isCollapsed ? 'rotated' : ''}`}
          />
        </button>
        <img src={logo} width="120" className={`mx-auto ${isCollapsed ? 'd-none' : ''}`} style={{marginBottom:'35px'}}/>
        {
          user && (user.role === 'admin' || user.role === 'merchant' || user.role === 'supplier' || user.role === 'staff' || user.role === 'merchant-staff') &&
            <Nav.Link
              className={`${(isActiveRoute(pathname, '/axis')) && 'active'}`}
              style={{paddingLeft: '23px'}}
              as={Link}
              to='/axis'
              title="PO"
            ><FontAwesomeIcon icon={solid('clipboard')} transform="grow-2" style={{margin: '0 15px 0 3px'}}/>
            {!isCollapsed && 'PO'}</Nav.Link>
        }
        {
          user && (user.role === 'admin') &&
            <Nav.Link
              className={`${(isActiveRoute(pathname, '/axis/import')) && 'active'}`}
              style={{paddingLeft: '23px'}}
              as={Link}
              to='/axis/import'
              title="Import PO"
            ><FontAwesomeIcon icon={solid('file-excel')}  style={{margin: '0 15px 0 3px'}}/>
            {!isCollapsed && 'Import PO'}</Nav.Link>
        }
        {/* <Nav.Link
          className={`${isActiveRoute(pathname, '/profile') && 'active'}`}
          style={{paddingLeft: '23px'}}
          as={Link}
          to="/profile"
          title="My Account"
        ><FontAwesomeIcon icon={solid('user')}  style={{margin: '0 15px 0 3px'}}/>
          {!isCollapsed && 'My Account'}
        </Nav.Link> */}
        {
          user && (user.role === 'admin' || user.role === 'staff') &&
          <Accordion className="nav-accordion" activeKey={isCollapsed ? null : "0"}>
            <Accordion.Item style={{border:'none', paddingLeft: '5px'}} eventKey="0">
                <Accordion.Header style={{color: '#80d7cf'}} title="Admin Tools">
                  <FontAwesomeIcon icon={solid('wrench')}  style={{margin: '0 15px 0 3px'}}/>
                  {!isCollapsed && (
                    "Admin Tools"
                  )}
                </Accordion.Header>
              <Accordion.Body className="pe-2" style={{marginLeft: '1.6rem'}}>
              {
                user && user.role === 'admin' &&
                  <Nav.Link
                    className={`${isActiveRoute(pathname, '/users') && 'active'}`}
                    as={Link}
                    to="/users"
                    style={{padding: '0.2rem 0', fontSize: '0.9em'}}
                  >
                    Users
                  </Nav.Link>
              }
                <Nav.Link
                  className={`${isActiveRoute(pathname, '/logs') && 'active'}`}
                  as={Link}
                  to="/logs"
                  style={{padding: '0.2rem 0', fontSize: '0.9em'}}
                > Activity Log
                </Nav.Link>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        }
        <Nav.Link className={`${isActiveRoute(pathname, '/logout') && 'active'} logout-btn`}
          style={{paddingLeft: '23px'}}
          as={Link}
          to="/logout"
          title="Log Out"
          ><FontAwesomeIcon icon={solid('arrow-right-from-bracket')} transform="flip-h"  style={{margin: '0 15px 0 3px'}}/>
          {!isCollapsed && 'Log Out'}
        </Nav.Link>
      </Nav>
  )
}

export default connect(state => {
  return {
    notifications: state.notifications
  }
})(Sidebar);
